import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-custom-apis',
  templateUrl: './custom-apis.component.html',
  styleUrls: ['./custom-apis.component.scss'],
})
export class CustomApisComponent extends BaseListCtl {
  /**
   * ID of the application to which this form belongs.
   */
  public appId: number = 0;
  public appName: String = '';
  public usecaseId: number = 0;

  public test_data: string = '';

  public usecaseSchema: any = {};

  public attributeId: number = 0;

  public uiformDataList = [];

  public api_server: string = '';

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.application.rules'), locator, route);
    let _self = this;
    _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));
    _self.form['userstoryId'] = _self.usecaseId;
    _self.form['isConfirmDelete'] = false;
    _self.api_server = locator.config.get('SERVER_URL');
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.description = data.description;
    form.rule = data.rule;
    form.url = data.url;
    if (form.id > 0) {
      form.code = data.code;
    }
  }

  override ngOnInit() {
    this.preload();
    this.search();
  }

  override search(): void {
    let _self = this;
    _self.form.searchParams['userstoryId'] = _self.usecaseId;
    super.search();
    this.display();
  }

  override resetForm() {
    super.resetForm();
    let _self = this;
    this.form.data['userstoryId'] = _self.usecaseId;
  }

  override save(): void {
    let _self = this;
    this.form.data['userstoryId'] = _self.usecaseId;
    this.form.data['applicationId'] = _self.appId;
    super.save();
  }

  public usecase: any = [];

  display() {
    this.getUsecaseSchema();
  }

  public attributeList: any = [];

  public selectedItemId: any;

  setSelectedItem(id: any) {
    this.selectedItemId = id;
  }

  confirmDelete() {
    this.delete(this.selectedItemId);
  }

  public getUsecaseSchema() {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/get/' +
      _self.usecaseId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecaseSchema = res.result.data;
      _self.appId = _self.usecaseSchema['appId'];
      _self.appName = _self.usecaseSchema['appName'];
      _self.getApplicationDetails(_self.appId);
      let attrUrl =
        _self.locator.config.get('endpoint.userstory.attributes') +
        '/list/' +
        _self.usecaseId;
      //{ userstoryId: _self.usecaseId },
      _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
        _self.attributeList = res.result.data;

        _self.getCustomApisList();
      });
    });
  }

  public customApisList: any = [];

  getCustomApisList() {
    let _self = this;
    let searchParams = {
      userstoryId: _self.usecaseId,
    };

    this.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/search/0';
        this.locator.http.post(
          url,
          searchParams,
          function (res: any, error: boolean) {
            _self.customApisList = res.result.data;
            _self.getApiList();
          }
        );
      });
  }

  override preload(): void {}

  endpoints: any = {};
  usecaseCode: any;

  getApiList() {
    let _self = this;
    this.usecaseCode = this.usecaseSchema.code;
    let appCode = this.usecaseSchema.appCode;
    let usecase_request_object = {};
    this.generateHelpObject(_self.attributeList);
    this.generateHelpExample(_self.attributeList);

    let common = 'api/v1/' + appCode + '/' + this.usecaseCode + '/';

    this.endpoints = [];
    this.endpoints.push({
      name: 'Save',
      method: 'Post',
      path: common + 'save',
      body: this.api_schema,
      request: _self.api_example,
      responses: [
        {
          Code: '200',
          Description: 'Success Save',
          response: {
            success: true,
            result: {
              data: _self.api_example,
              message: 'Data is saved',
            },
          },
        },
      ],
    });

    this.endpoints.push({
      name: 'Get',
      method: 'Get',
      path: common + 'get' + '/{id}',
      parameters: [
        {
          name: 'id',
          description: 'ID of ' + this.usecaseCode + ' to get',
        },
      ],
      responses: [
        {
          Code: '200',
          Description: 'Get data of ' + this.usecaseCode,
          response: {
            success: true,
            result: {
              data: _self.api_example,
            },
            message: '',
          },
        },
      ],
    });

    this.endpoints.push({
      name: 'search',
      method: 'Post',
      path: common + 'search' + '/{page}',
      request: _self.api_example,
      parameters: [
        {
          name: 'page',
          description: 'page no ' + this.usecaseCode + ' to get . optional',
          optional: true,
        },
      ],
      responses: [
        {
          Code: '200',
          Description: 'Get data of ' + this.usecaseCode,
          response: {
            success: true,
            result: {
              pageCount: 1,
              data: [_self.api_example],
              pageNo: 0,
              recordCount: 2,
              pageSize: 50,
            },
            message: '',
          },
        },
      ],
    });

    this.endpoints.push({
      name: 'Delete',
      method: 'Get',
      path: common + 'delete' + '/{id}',

      parameters: [
        {
          name: 'id',
          description: 'Id of  ' + this.usecaseCode + ' to delete',
        },
      ],
      responses: [
        {
          Code: '200',
          Description: 'Get data of ' + this.usecaseCode,
          response: {
            success: true,
            message: 'Record is deleted',
          },
        },
      ],
    });

    this.endpoints.push({
      name: 'Find',
      method: 'Get',
      path: common + 'find' + '/{attrib}/{value}',
      parameters: [
        {
          name: 'attrib',
          description:
            'attribute name of  ' + this.usecaseCode + ' to use for find data',
        },
        {
          name: 'value',
          description: 'value of attribute name in ' + this.usecaseCode,
        },
      ],
      responses: [
        {
          Code: '200',
          Description: 'Get data of ' + this.usecaseCode,
          response: {
            success: true,
            result: {
              pageCount: 1,
              data: [_self.api_example],
              pageNo: 0,
              recordCount: 2,
              pageSize: 50,
            },
            message: '',
          },
        },
      ],
    });
    // add custom apis docs

    _self.customApisList.forEach((apis: any) => {
      let common1 = 'api/v1/exe/';
      this.endpoints.push({
        name: apis['name'],
        method: 'Post',
        path: common1 + apis['code'],
        body: this.api_schema,
        request: _self.api_example,
        custom: true,
        responses: [
          {
            Code: '200',
            Description: 'Success Save',
            response: {
              success: true,
              result: {
                data: _self.api_example,
                message: 'Data is saved',
              },
            },
          },
        ],
      });
    });
  }

  api_schema: any = {};
  api_example: any = {};

  generateHelpObject(attributes: any[]) {
    attributes.forEach((attr) => {
      this.api_schema[attr.code] = {
        description: `The ${attr.label.toLowerCase()}.`, // Dynamic description based on label
        type: this.mapType(attr.type),
        required: attr.required,
        notes: this.generateNotes(attr),
      };
    });
  }

  generateHelpExample(attributes: any[]) {
    attributes.forEach((attr) => {
      this.api_example[attr.code] = this.getValue(attr.type);
    });
    this.test_data = JSON.stringify(this.api_example, null, 2);
  }

  // Helper method to map the type to readable format
  mapType(type: string): string {
    switch (type) {
      case 'text':
        return 'string';
      case 'long':
        return 'integer';
      case 'number':
        return 'number (float)';
      case 'list':
        return 'string (list)';
      default:
        return 'unknown';
    }
  }

  getValue(type: string): any {
    switch (type) {
      case 'text':
        return this.getRandomString();
      case 'long':
        return Math.floor(Math.random() * 1000000000);
      case 'number':
        return parseFloat((Math.random() * 10000).toFixed(2));
      case 'list':
        return this.getRandomList();
      default:
        return '';
    }
  }

  getRandomString() {
    const names = ['John Doe', 'Jane Smith', 'Alice Johnson', 'Bob Brown'];
    return names[Math.floor(Math.random() * names.length)];
  }

  getRandomList() {
    const names = ['abc', 'xyz'];
    return names;
  }

  // Helper method to generate notes dynamically
  generateNotes(attr: any): string {
    let notes = '';
    if (attr.unique) {
      notes += 'Must be unique for each entry. ';
    }
    if (attr.type === 'list' && attr.values) {
      notes += `Valid values: ${attr.values.join(', ')}. `;
    }
    return notes.trim();
  }

  public exe_result: any;

  execute() {
    let _self = this;

    let data = JSON.parse(this.test_data);
    this.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/exe/' + _self.form.data['code'];
        this.locator.http.post(url, data, function (res: any, error: any) {
          if (error) {
            alert(error);
            return;
          }
          _self.exe_result = JSON.stringify(res, null, 2);
        });
      });
  }

  update_testdata(event: Event) {
    const textareaValue = (event.target as HTMLTextAreaElement).value;
    this.test_data = textareaValue;
  }

  /**
   * Contains attribute data
   */
  public applicationForm: any = {
    error: false, //error
    message: null, //error or success message
    preload: null, // preload data
    inputerror: {}, // form input error messages
    data: {},
  };
  /**
   * Get Application details
   */
  getApplicationDetails(id: any) {
    let _self = this;
    //localhost:8085/ctl/application/get/10087390
    let url = _self.locator.config.get('endpoint.application') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationForm['error'] = !res.success;
      _self.applicationForm['message'] = res.message;
      _self.applicationForm['inputerror'] = res.result['inputerror'];

      if (res.success) {
        _self.applicationForm['data'] = res.result['data'];
      }
    });
  }
}
